import { DataAttributeDefinitions } from 'scrivito'

import { pisaActivityContactRelationDataClass } from './Pisa/pisaActivityContactRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const ActivityContactRelation =
  pisaActivityContactRelationDataClass(attributes)
